(function (angular) {
    'use strict';

    angular.module('broadcast')

        /**
         *
         */
        .factory('broadcastWizardService',
            ["$state", "$stateParams", "utilService", "profilesService", "audiencesService", "facebookService", "inboundService", "teamSettingsService", "broadcastService", "growlService", "customChannelService", "whatsAppServices", "permittedChannels", "$q",
                function ($state, $stateParams, utilService, profilesService, audiencesService, facebookService, inboundService, teamSettingsService, broadcastService, growlService, customChannelService, whatsAppServices, permittedChannels, $q) {

                    /**
                     * Serialize a broadcast into the individual step models
                     * @param {*} broadcast 
                     */
                    function _serialise(broadcast) {
                        /**
                         * Step 1 
                         */
                        fac.step1Model = {
                            id: broadcast.id,
                            name: broadcast.name,
                            requireOptIn: broadcast.requireOptIn,
                            channel: broadcast.rules ? broadcast.rules[0] : undefined
                        };

                        /**
                         * Step 2 
                         */
                        fac.step2Model = {
                            messageParts: []
                        };

                        if (broadcast.content) {

                            if (broadcast.content.body) {

                                fac.step2Model.messageParts.push({
                                    type: 'text/plain',
                                    data: broadcast.content.body
                                });

                            } else if (broadcast.content.messageParts) {
                                fac.step2Model.messageParts = broadcast.content.messageParts;

                                // add an arbitrary id so we can track in repeater and give a name in forms
                                angular.forEach(fac.step2Model.messageParts, function (part) {
                                    part.id = utilService.uuid()
                                })
                            }
                        }

                        if (broadcast.channelOptions) {
                            if (broadcast.channelOptions.sms) {
                                fac.step2Model.from = broadcast.channelOptions.sms.from;

                                if (broadcast.channelOptions.sms.from) {
                                    // which sms type to pick
                                    if (fac.dedicatedNumbers && fac.dedicatedNumbers.map(function (x) { return x.number; }).includes(fac.step2Model.from)) {
                                        fac.step2Model.smsOriginatorType = "DEDICATED_LONG_NUMBER";
                                    } else {
                                        fac.step2Model.smsOriginatorType = "ALPHA_ORIGINATOR";
                                    }

                                } else {
                                    fac.step2Model.smsOriginatorType = "POOL_NUMBER";
                                }



                            }
                            else if (broadcast.channelOptions.fbMessenger) {
                                fac.step2Model.messageTag = broadcast.channelOptions.fbMessenger.messageTag;
                            }
                            else if (broadcast.channelOptions.appMessaging) {
                                fac.step2Model.teamName = broadcast.channelOptions.appMessaging.from.profileId.split('\\')[1];
                            }
                            else if (broadcast.channelOptions.whatsApp) {
                                var messagePartData = broadcast.content.messageParts[0].data;

                                fac.step2Model.from = broadcast.channelOptions.whatsApp.phoneNumber;

                                var hsmParams = messagePartData.parameters.reduce(function (acc, cur, i) {
                                    acc[i] = cur.default;
                                    return acc;
                                }, {});

                                fac.step2Model.tempTemplateName = messagePartData.templateName;
                                fac.step2Model.hsmLanguageCode = messagePartData.languageCode;
                                fac.step2Model.hsmParams = hsmParams;
                            }
                        }

                        /**
                         * Step 3
                         */
                        fac.step3Model = {
                            audienceId: broadcast.to ? broadcast.to.audiences[0] : undefined
                        };

                        /**
                         * Step 4
                         */
                        fac.step4Model = {
                            expiresAfter: broadcast.expiresAfter,
                            schedule: broadcast.schedule
                        };
                    }

                    /**
                     * Load a broadcast and serialise
                     * @param {*} apiSpaceId 
                     * @param {*} broadcastId 
                     */
                    function _load(apiSpaceId, broadcastId) {
                        return broadcastService.getBroadcast(apiSpaceId, broadcastId)
                            .then(function (broadcast) {
                                _serialise(broadcast);
                                return broadcast;
                            });
                    }

                    function _getProfileSchema(apiSpaceId) {
                        var profileSchema = [];
                        return profilesService.getProfileSchema(apiSpaceId)
                            .then(function (result) {
                                result.fields.forEach(function (field) {
                                    if (!field.onlyObjects && !field.name.startsWith('_') && field.name != 'id') {
                                        profileSchema.push(field);
                                    }
                                });

                                return profileSchema;
                            });
                    }


                    var fac = {
                        /**
                         * Initialise the wizard service ...
                         * 
                         * @params {String} apiSpaceId
                         * @params {String} broadcastId
                         * @params {Boolean} isNew
                         */
                        initialise: function (apiSpaceId, broadcastId, isNew, seed) {

                            return _getProfileSchema(apiSpaceId)
                                .then(function (profileSchema) {
                                    fac.profileSchema = profileSchema;
                                    return audiencesService.getAudiences(apiSpaceId);
                                })
                                .then(function (audiences) {
                                    fac.audiences = audiences.filter(function (a) {
                                        return a.isTest !== true;
                                    });

                                    fac.testAudiences = audiences.filter(function (a) {
                                        return a.isTest === true;
                                    });
                                    return inboundService.getDedicatedNumbers(apiSpaceId)
                                })
                                .then(function (numbers) {
                                    fac.dedicatedNumbers = numbers;
                                    return inboundService.getShortcodes(apiSpaceId)
                                })
                                .then(function (shortcodes) {
                                    fac.shortcodes = shortcodes;
                                    // this will rturn a 404 if a page hasn't been configured
                                    return facebookService.getPageFromComapi(apiSpaceId)
                                        .then(function (result) { return result; })
                                        .catch(function (error) { return undefined; })
                                })
                                .then(function (page) {
                                    fac.fbPage = page;
                                    // this will rturn a 404 if a page hasn't been configured
                                    return facebookService.getTags(apiSpaceId)
                                        .then(function (result) { return result; })
                                        .catch(function (error) { return []; })
                                })
                                .then(function (tags) {

                                    angular.forEach(tags, function (tag) {
                                        tag.name = tag.tag.toLowerCase().replace(/_/g, " ");
                                        tag.name = tag.name.charAt(0).toUpperCase() + tag.name.slice(1);
                                    });
                                    fac.possibleFbTags = tags;

                                    return teamSettingsService.getTeams(apiSpaceId);
                                })
                                .then(function (teams) {
                                    fac.teams = teams;
                                    if (permittedChannels.canRead('whatsApp')) {
                                        return whatsAppServices.getAllWhatsAppConfigurations(apiSpaceId)
                                    } else {
                                        return $q.resolve([]);
                                    }
                                })
                                .then(function (whatsAppConfigurations) {
                                    fac.whatsAppConfigurations = whatsAppConfigurations || [];
                                    fac.whatsAppConfigurations = fac.whatsAppConfigurations.filter((config) => config.verificationStatus === "completed");
                                    fac.hsms = [];
                                    return customChannelService.getPossibleChannels(apiSpaceId);
                                })
                                .then(function (possibleChannels) {
                                    fac.possibleChannels = possibleChannels;
                                    if (!isNew) {
                                        // load existing ...
                                        return _load(apiSpaceId, broadcastId)
                                            .then(function (ret) {
                                                return fac;
                                            })
                                            .catch(function (error) {
                                                console.error(error);
                                                fac.reset(broadcastId);
                                                return fac;
                                            })

                                    } else {
                                        // initialise blank (we will supply the id when we create)
                                        fac.reset(broadcastId);
                                        return fac;
                                    }
                                });
                        },
                        /**
                         * 
                         */
                        getBroadcastData: function () {
                            var broadcast = {
                                id: fac.step1Model.id,
                                name: fac.step1Model.name,
                                requireOptIn: fac.step1Model.requireOptIn
                            };

                            // Message content
                            if (fac.step2Model.messageParts.length == 1 && fac.step1Model.channel == 'sms' && fac.step2Model.messageParts[0].data) {
                                broadcast.content = {
                                    body: fac.step2Model.messageParts[0].data
                                };
                            }
                            else if (fac.step2Model.messageParts.length >= 1 && fac.step1Model.channel != 'sms') {
                                broadcast.content = {
                                    messageParts: fac.step2Model.messageParts
                                };
                            }
                            // validity
                            if (fac.step4Model.expiresAfter) {
                                broadcast.expiresAfter = fac.step4Model.expiresAfter;
                            }

                            // audience
                            if (fac.step3Model.audienceId) {
                                broadcast.to = {
                                    audiences: [fac.step3Model.audienceId]
                                };
                            }

                            // channel
                            if (fac.step1Model.channel) {
                                broadcast.channelOptions = {};
                                broadcast.rules = [fac.step1Model.channel];
                                if (fac.step1Model.channel == 'sms' /*&& broadcastData.number && broadcastData.msgData*/) {
                                    broadcast.channelOptions.sms = {
                                        allowUnicode: true /* broadcastData.msgData.bIsUnicode*/,
                                        // server validation will fail on empty string as is < 3 chars
                                        // no from means pool number ...
                                        from: fac.step2Model.from !== "" ? fac.step2Model.from : undefined
                                    };
                                }
                                else if (fac.step1Model.channel == 'fbMessenger' && fac.fbPage) {
                                    broadcast.channelOptions.fbMessenger = {
                                        messageTag: fac.step2Model.messageTag,
                                        messagingType: 'MESSAGE_TAG'
                                    };
                                }
                                else if (fac.step1Model.channel == 'appMessaging' && fac.step2Model.teamName) {
                                    broadcast.channelOptions.appMessaging = {
                                        from: {
                                            profileId: "TEAM\\" + fac.step2Model.teamName
                                        }
                                    };
                                    broadcast.conversationId = fac.step2Model.teamName + "_{{profile.profileId}}";
                                }
                                else if (fac.step1Model.channel === 'whatsApp' && fac.step2Model.hsm) {
                                    //creating fake content and body to pass validation 

                                    var hsmParams = Object.keys(fac.step2Model.hsmParams).map(function (key) {
                                        return { default: fac.step2Model.hsmParams[key] };
                                    });

                                    broadcast.content = {
                                        messageParts: [{
                                            type: "whatsapp/template",
                                            data: {
                                                namespace: fac.step2Model.hsm.namespace,
                                                templateName: fac.step2Model.hsm.templateName,
                                                languageCode: fac.step2Model.hsmLanguageCode,
                                                parameters: hsmParams
                                            }
                                        }]
                                    };

                                    broadcast.channelOptions.whatsApp = {
                                        phoneNumber: fac.step2Model.from
                                    }
                                }
                            }
                            return broadcast;
                        },
                        /**
                         * 
                         */
                        reset: function (broadcastId) {
                            fac.step1Model = {
                                id: broadcastId
                            };
                            fac.step2Model = {};
                            fac.step3Model = {};
                            fac.step4Model = {};
                        },
                        /**
                         * 
                         */
                        createBroadcast: function () {
                            var broadcast = fac.getBroadcastData();

                            return broadcastService.createBroadcast($stateParams.pickedApiSpaceId, broadcast)
                                .then(function (result) {
                                    growlService.success('Broadcast created');
                                    return true;
                                })
                                .catch(function (error) {
                                    console.error(error);
                                    growlService.danger("Broadcast creation failed:" + error.statusText);
                                    return false;
                                })
                        },
                        /**
                         * @Param {Boolean} doGrowl - whether to growl success / failure 
                         *  - this function is internally used as part of testBroadcast and that will want to be growling too 😂
                         */
                        updateBroadcast: function (doSuccessGrowl) {

                            if (doSuccessGrowl === undefined) {
                                doSuccessGrowl = true
                            }

                            var broadcast = fac.getBroadcastData();

                            return broadcastService.updateBroadcast($stateParams.pickedApiSpaceId, broadcast)
                                .then(function (result) {
                                    if (doSuccessGrowl) {
                                        growlService.success('Broadcast updated');
                                    }

                                    return true;
                                })
                                .catch(function (error) {
                                    if (error.status === 404) {
                                        // try and create it
                                        return fac.createBroadcast();
                                    } else {
                                        console.error(error);
                                        growlService.danger("Broadcast update failed:" + error.statusText);
                                        return false;
                                    }
                                })
                        },
                        /**
                         * 
                         */
                        sendBroadcast: function () {

                            return broadcastService.sendBroadcast($stateParams.pickedApiSpaceId, fac.step1Model.id)
                                .then(function (result) {
                                    growlService.success('Broadcast Sent');
                                    $state.go('main.apiSpace.reports.broadcast', { channelId: fac.step1Model.channel });
                                    return true;
                                })
                                .catch(function (error) {
                                    console.error(error);
                                    growlService.danger("Broadcast Send failed: " + error.statusText);
                                    return false;
                                })
                        },

                        /**
                         * 
                         */
                        scheduleBroadcast: function () {

                            return broadcastService.scheduleBroadcast($stateParams.pickedApiSpaceId, fac.step1Model.id, fac.step4Model.schedule).then(function (result) {
                                growlService.success("Successfully scheduled broadcast");
                                $state.go('main.apiSpace.existingBroadcasts', { type: "scheduled" });
                                return true;
                            }).catch(function (result) {
                                growlService.danger("There was a problem with scheduling broadcast, try again");
                                return false;
                            });
                        },

                        /**
                         * 
                         */
                        testBroadcast: function () {

                            return fac.updateBroadcast(false)
                                .then(function (updated) {

                                    if (updated) {
                                        var options = {
                                            to: {
                                                audiences: [fac.step2Model.testAudience.id]
                                            }
                                        };
                                        return broadcastService.testBroadcast($stateParams.pickedApiSpaceId, fac.step1Model.id, options)
                                            .then(function (result) {
                                                growlService.success("Successfully sent test broadcast to chosen audience");
                                                return true;
                                            }).catch(function (result) {
                                                growlService.danger("There was a problem with sending test broadcast, try again");
                                                return false;
                                            });

                                    } else {
                                        growlService.danger("Broadcast update failed");
                                        return updated;
                                    }
                                });
                        },
                        step1Model: {
                        },
                        step2Model: {
                        },
                        step3Model: {
                        },
                        step4Model: {
                        },

                    };

                    return fac;

                }]);

})(window.angular);